module.exports = __webpack_public_path__ + "static/img/3.5fae4a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news14/3.png
// module id = TA9k
// module chunks = 1